export default __webpack_public_path__ + "images/indeed-flex-plus-logo-bb9164.svg";